var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticStyle:{"height":"100%"}},[_c('v-tip'),(_vm.$route.name !== 'homeT')?_c('router-view'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }